module.exports = __webpack_public_path__ + "static/img/language.e9eec2a7.png";